const conConfig = {
    service: {
        listLayout: 'ConfigListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'ConfigFilterDefaultLayout',
        isCategory: false,
        listApiParamSet: {
            ip: 1,
            c_type: 'service',
        },
        paginationType: 'pagination',
        pageRow: 10,
    },

    servieCreate: {
        getFunc: 'getConfig',
        getCategoryFunc: null,
        optionLayouts: ['ConfigInputLayout'],
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        parsingData: {
            content: 'cs_stipulation',
            c_idx: 'c_idx',
        },
        subFunc: 'createConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '서비스 이용약관이 등록되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: 'back',
    },

    servieUpdate: {
        getFunc: 'getConfig',
        optionLayouts: ['ConfigInputLayout'],
        parsingData: {
            content: 'cs_stipulation',
            c_idx: 'c_idx',
        },
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        subFunc: 'updateConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '서비스 이용약관이 수정되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: '',
    },

    policy: {
        listLayout: 'ConfigListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'ConfigFilterDefaultLayout',
        isCategory: false,
        listApiParamSet: {
            ip: 1,
            c_type: 'service',
        },
        paginationType: 'pagination',
        pageRow: 10,
    },

    policyCreate: {
        getFunc: 'getConfig',
        getCategoryFunc: null,
        optionLayouts: ['ConfigInputLayout'],
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        parsingData: {
            content: 'cs_privacy',
            c_idx: 'c_idx',
        },
        subFunc: 'createConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '개인정보처리방침 등록되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: 'back',
    },

    policyUpdate: {
        getFunc: 'getConfig',
        optionLayouts: ['ConfigInputLayout'],
        parsingData: {
            content: 'cs_privacy',
            c_idx: 'c_idx',
        },
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        subFunc: 'updateConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '개인정보처리방침 수정되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: '',
    },

    refund: {
        listLayout: 'ConfigListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'ConfigFilterDefaultLayout',
        isCategory: false,
        listApiParamSet: {
            ip: 1,
            c_type: 'service',
        },
        paginationType: 'pagination',
        pageRow: 10,
    },

    refundCreate: {
        getFunc: 'getConfig',
        getCategoryFunc: null,
        optionLayouts: ['ConfigInputLayout'],
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        parsingData: {
            content: 'cs_refund',
            c_idx: 'c_idx',
        },
        subFunc: 'createConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '환불 약관이 등록되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: 'back',
    },

    refundUpdate: {
        getFunc: 'getConfig',
        optionLayouts: ['ConfigInputLayout'],
        parsingData: {
            content: 'cs_refund',
            c_idx: 'c_idx',
        },
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        subFunc: 'updateConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '환불 약관이 수정되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: '',
    },


    leave: {
        listLayout: 'ConfigListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'ConfigFilterDefaultLayout',
        isCategory: false,
        listApiParamSet: {
            ip: 1,
            c_type: 'service',
        },
        paginationType: 'pagination',
        pageRow: 10,
    },

    leaveCreate: {
        getFunc: 'getConfig',
        getCategoryFunc: null,
        optionLayouts: ['ConfigInputLayout'],
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        parsingData: {
            content: 'cs_leave',
            c_idx: 'c_idx',
        },
        subFunc: 'createConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '회원탈퇴약관이 등록되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: 'back',
    },

    leaveUpdate: {
        getFunc: 'getConfig',
        optionLayouts: ['ConfigInputLayout'],
        parsingData: {
            content: 'cs_leave',
            c_idx: 'c_idx',
        },
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        subFunc: 'updateConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '회원탈퇴약관이 수정되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: '',
    },

    credit: {
        listLayout: 'ConfigListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'ConfigFilterDefaultLayout',
        isCategory: false,
        listApiParamSet: {
            ip: 1,
            c_type: 'service',
        },
        paginationType: 'pagination',
        pageRow: 10,
    },

    creditCreate: {
        getFunc: 'getConfig',
        getCategoryFunc: null,
        optionLayouts: ['ConfigInputLayout'],
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        parsingData: {
            content: 'cs_credit_msg',
            c_idx: 'c_idx',
        },
        subFunc: 'createConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '결제 약관이 등록되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: 'back',
    },

    creditUpdate: {
        getFunc: 'getConfig',
        optionLayouts: ['ConfigInputLayout'],
        parsingData: {
            content: 'cs_credit_msg',
            c_idx: 'c_idx',
        },
        detailApiParamSet: {
            ip: 0,
            c_type: 'service',
        },
        subFunc: 'updateConfig',
        createApiParamSet: {
            c_type: 'service',
        },
        resultAlertTxt: '결제 약관이 수정되었습니다.',
        validateAlertText: '모두 입력해주세요',
        directUrl: '',
    },


}

export default {
    methods: {
        returnConConfig(type) {
            return conConfig[type];
        }
    },
    filterConfig: {
        cid: {
            type: 'match',
            classname: 'filterCountry'
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        cr: {
            type: 'between',
            classname: 'filterDate',
        }
    }
}
